/* Sharky Pyjamas — satın alma akışı ve ölçülü hareketler.
   Hareketler azaltılmış hareket tercihine saygı duyar; beden kapısı, durum mesajları ve diyalog tercihten bağımsız çalışır. */
(function () {
  'use strict';
  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function q(sel, ctx) {
    return (ctx || d).querySelector(sel);
  }
  function qa(sel, ctx) {
    return Array.prototype.slice.call((ctx || d).querySelectorAll(sel));
  }
  function ready(fn) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // At >=990px base.css moves the page scroll into .page-wrapper, so window.scrollY stays 0 there.
  function scroller() {
    var w = q('.page-wrapper');
    if (w) {
      var o = window.getComputedStyle(w).overflowY;
      if ((o === 'auto' || o === 'scroll') && w.scrollHeight > w.clientHeight + 1) return w;
    }
    return null;
  }
  function scrollPos() {
    var s = scroller();
    return s ? s.scrollTop : window.scrollY || window.pageYOffset || 0;
  }
  function scrollSpan() {
    var s = scroller();
    return s ? s.scrollHeight - s.clientHeight : root.scrollHeight - window.innerHeight;
  }
  // scroll does not bubble: listen in the capture phase on the document to catch window and element scrollers
  function onAnyScroll(fn) {
    d.addEventListener('scroll', fn, { passive: true, capture: true });
  }
  function onScroll() {
    root.classList.toggle('sk-scrolled', scrollPos() > 6);
  }
  onAnyScroll(onScroll);
  onScroll();

  /* ---------- Satın alma akışı ---------- */
  var sizeChosen = /[?&]variant=/.test(window.location.search);
  var inflight = false;
  var inflightTimer = 0;
  var kbd = false;
  var noteTimer = 0;
  var noteActive = false;
  var lastOpener = null;
  var ticking = false;

  function sizeInputs() {
    return qa('input[data-option-name="Size"]');
  }
  function checkedSize() {
    var i = q('input[data-option-name="Size"]:checked');
    return i ? i.value : '';
  }
  // Beden seçilmeden satın alma yapılamaz; varsayılan beden rastgele eklenmez
  function pending() {
    return !designMode && !sizeChosen && sizeInputs().length > 1;
  }
  function syncPending() {
    if (pending()) root.setAttribute('data-sk-pending', '');
    else root.removeAttribute('data-sk-pending');
  }
  function mainButton() {
    return q('product-form-component .add-to-cart-button');
  }
  function isDisabled(b) {
    return !b || b.disabled || b.getAttribute('aria-disabled') === 'true' || (b.dataset && b.dataset.disabled === 'true');
  }
  function cartUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
  }
  function shortName(n) {
    return String(n || 'Sharky onesie').split(/\s[–—-]\s/)[0];
  }

  function placeNode(el, where) {
    var pf = q('product-form-component');
    if (!pf || !pf.parentNode) return false;
    pf.parentNode.insertBefore(el, where === 'before' ? pf : pf.nextSibling);
    return true;
  }
  function ensureSizeError() {
    var el = d.getElementById('sk-size-error');
    if (el && el.isConnected) return el;
    el = d.createElement('p');
    el.id = 'sk-size-error';
    el.className = 'sk-error';
    el.setAttribute('role', 'alert');
    el.hidden = true;
    return placeNode(el, 'before') ? el : null;
  }
  function ensureStatus() {
    var el = d.getElementById('sk-status');
    if (el && el.isConnected) return el;
    el = d.createElement('div');
    el.id = 'sk-status';
    el.className = 'sk-status';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    return placeNode(el, 'after') ? el : null;
  }
  function links(into) {
    into.appendChild(d.createTextNode(' '));
    var a = d.createElement('a');
    a.href = cartUrl();
    a.textContent = 'View cart';
    into.appendChild(a);
    into.appendChild(d.createTextNode(' · '));
    var b = d.createElement('a');
    b.href = '/checkout';
    b.textContent = 'Check out';
    into.appendChild(b);
  }
  function say(text, state, withLinks) {
    var el = ensureStatus();
    if (!el) return;
    el.setAttribute('data-state', state || 'info');
    el.textContent = text;
    if (withLinks) links(el);
    // Alt çubuk görünürken mesaj orada da gösterilir (ana düğme ekran dışında)
    stickyNote(text, withLinks);
  }
  function stickyNote(text, withLinks) {
    var bar = d.getElementById('sk-sticky');
    var line = bar && q('[data-sk-size]', bar);
    if (!line || !bar.classList.contains('is-visible')) return;
    noteActive = true;
    line.textContent = text;
    if (withLinks) links(line);
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      noteActive = false;
      syncStickyText();
    }, 7000);
  }

  function showSizeError() {
    var el = ensureSizeError();
    if (!el) return;
    el.textContent = '';
    el.hidden = false;
    window.setTimeout(function () {
      el.textContent = 'Please choose a size to continue.';
    }, 30);
    var inp = q('input[data-option-name="Size"]:checked') || q('input[data-option-name="Size"]');
    var fs = inp && inp.closest('fieldset');
    if (!fs) return;
    inp.setAttribute('aria-describedby', 'sk-size-error');
    // Beden seçenekleri ve hata mesajı birlikte görünsün: alan, sabit başlığın hemen altına gelir
    var hdr = q('header-component');
    var hh = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
    var sc = scroller();
    var top = sc
      ? sc.scrollTop + fs.getBoundingClientRect().top - sc.getBoundingClientRect().top - hh - 12
      : fs.getBoundingClientRect().top + (window.pageYOffset || 0) - hh - 12;
    (sc || window).scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    try {
      inp.focus({ preventScroll: true });
    } catch (e) {
      inp.focus();
    }
  }
  function hideSizeError() {
    var el = d.getElementById('sk-size-error');
    if (el) {
      el.hidden = true;
      el.textContent = '';
    }
    sizeInputs().forEach(function (i) {
      i.removeAttribute('aria-describedby');
    });
  }
  function chooseSize() {
    sizeChosen = true;
    syncPending();
    hideSizeError();
    syncStickyText();
    updateSticky();
  }

  function setBusy(on) {
    var btns = qa('product-form-component .add-to-cart-button');
    var sb = q('#sk-sticky [data-sk-sticky-btn]');
    if (sb) btns.push(sb);
    btns.forEach(function (b) {
      if (on) {
        b.classList.add('sk-busy');
        b.setAttribute('aria-busy', 'true');
      } else {
        b.classList.remove('sk-busy');
        b.removeAttribute('aria-busy');
      }
    });
  }
  function beginAdd() {
    inflight = true;
    setBusy(true);
    say('Adding to cart…', 'info');
    window.clearTimeout(inflightTimer);
    // Yanıt hiç dönmezse düğme sonsuza dek kilitli kalmasın
    inflightTimer = window.setTimeout(function () {
      if (inflight) endAdd(false, null, true);
    }, 20000);
  }
  function endAdd(ok, data, netErr) {
    window.clearTimeout(inflightTimer);
    inflight = false;
    setBusy(false);
    if (ok) {
      var item = data && ((data.items && data.items[0]) || data);
      var name = shortName(item && (item.product_title || item.title));
      var variant = item && item.variant_title ? ' · ' + item.variant_title : '';
      say('Added to cart: ' + name + variant + '.', 'ok', true);
    } else if (netErr) {
      say('We could not reach the store. Your selection is saved. Please check your connection and try again.', 'error');
    } else {
      var why = data && (data.description || data.message);
      if (why && !/[.!?]$/.test(why)) why += '.';
      say('We could not add this to your cart' + (why ? ': ' + why : '.') + ' Your selection is saved. Please try again.', 'error');
    }
    syncStickyText();
  }

  // Sepete ekleme isteğini izle: başarıyı yalnızca gerçek yanıt gelince göster
  var nativeFetch = window.fetch;
  if (nativeFetch && !window.__skFetch) {
    window.__skFetch = true;
    window.fetch = function (input) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || String(input);
      } catch (e) {}
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return nativeFetch.apply(this, arguments);
      beginAdd();
      var p = nativeFetch.apply(this, arguments);
      p.then(
        function (res) {
          var c = res.clone();
          return c.json().then(
            function (data) {
              endAdd(res.ok && !(data && data.status), data);
            },
            function () {
              endAdd(res.ok, null);
            }
          );
        },
        function () {
          endAdd(false, null, true);
        }
      );
      return p;
    };
  }

  // Gönderim kapısı: yinelenen gönderimi ve bedensiz satın almayı engelle
  d.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
      if (inflight) {
        e.preventDefault();
        e.stopImmediatePropagation();
      } else if (pending()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showSizeError();
      }
    },
    true
  );
  d.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var atc = t.closest('product-form-component .add-to-cart-button');
      var buy = t.closest('product-form-component .shopify-payment-button, product-form-component shopify-accelerated-checkout');
      if (!atc && !buy) return;
      if (inflight && atc) {
        e.preventDefault();
        e.stopImmediatePropagation();
      } else if (pending()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showSizeError();
      }
    },
    true
  );

  // Beden seçildi (fare, dokunma ve klavye)
  function onPick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var label = t.closest('label.variant-option__button-label');
    if (label && label.querySelector('input[data-option-name="Size"]')) chooseSize();
    if (label) {
      window.setTimeout(syncStickyText, 250);
      window.setTimeout(syncStickyText, 700);
    }
  }
  d.addEventListener('click', onPick);
  d.addEventListener('change', onPick);
  d.addEventListener('variant:update', function () {
    window.setTimeout(syncStickyText, 60);
  });

  /* ---------- Mobil alt satın alma çubuğu ---------- */
  function syncBanner() {
    var b = d.getElementById('shopify-pc__banner');
    var h = 0;
    if (b) {
      var cs = window.getComputedStyle(b);
      var r = b.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.bottom > window.innerHeight - 4) h = Math.round(r.height);
    }
    root.style.setProperty('--sk-banner', h + 'px');
  }
  function syncStickyText() {
    var bar = d.getElementById('sk-sticky');
    if (!bar) return;
    var priceEl = q('product-price .price') || q('product-price');
    var pe = q('[data-sk-price]', bar);
    if (pe && priceEl) pe.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
    var se = q('[data-sk-size]', bar);
    var sz = checkedSize();
    if (se && !noteActive) se.textContent = !pending() && sz ? 'Size: ' + sz : 'Size: not selected';
    var btn = q('[data-sk-sticky-btn]', bar);
    var main = mainButton();
    if (!btn) return;
    if (pending()) {
      btn.textContent = 'Choose size';
      btn.disabled = false;
    } else if (isDisabled(main)) {
      btn.textContent = main ? main.textContent.replace(/\s+/g, ' ').trim() || 'Unavailable' : 'Unavailable';
      btn.disabled = true;
    } else {
      btn.textContent = 'Add to cart';
      btn.disabled = false;
    }
  }
  function updateSticky() {
    var bar = d.getElementById('sk-sticky');
    if (!bar) return;
    syncBanner();
    var btn = mainButton();
    var show = false;
    if (btn && window.matchMedia('(max-width: 749px)').matches && !kbd) {
      var r = btn.getBoundingClientRect();
      show = (r.bottom < 0 || r.top > window.innerHeight) && !q('dialog[open], cart-drawer[open], .shopify-payment-button__more-options[aria-expanded="true"]');
    }
    if (show && !bar.classList.contains('is-visible')) {
      syncStickyText();
      root.style.setProperty('--sk-sticky-h', bar.offsetHeight + 'px');
    }
    bar.classList.toggle('is-visible', show);
  }
  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      updateSticky();
    });
  }
  function isTextEntry(el) {
    return !!el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && !/^(radio|checkbox|button|submit|range|file|image|reset|color)$/i.test(el.type || '');
  }
  function initSticky() {
    var bar = d.getElementById('sk-sticky');
    if (!bar) return;
    if (designMode || !mainButton()) {
      bar.remove();
      return;
    }
    bar.hidden = false;
    syncStickyText();
    onAnyScroll(requestUpdate);
    window.addEventListener('resize', requestUpdate);
    d.addEventListener('focusin', function (e) {
      if (isTextEntry(e.target)) {
        kbd = true;
        bar.classList.add('sk-kbd');
      }
    });
    d.addEventListener('focusout', function () {
      kbd = false;
      bar.classList.remove('sk-kbd');
      window.setTimeout(requestUpdate, 60);
    });
    d.addEventListener('click', function () {
      window.setTimeout(requestUpdate, 350);
    });
    updateSticky();
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-sk-sticky-btn]');
    if (!b || inflight) return;
    if (pending()) {
      showSizeError();
      return;
    }
    var main = mainButton();
    if (main && !isDisabled(main)) main.click();
  });

  /* ---------- Beden rehberi diyaloğu ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var o = t.closest('[data-sk-open]');
    if (o) {
      var dlg = d.getElementById(o.getAttribute('data-sk-open'));
      if (!dlg) return;
      lastOpener = o;
      o.setAttribute('aria-expanded', 'true');
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
      return;
    }
    var c = t.closest('[data-sk-close]');
    if (c) {
      var dl = c.closest('dialog');
      if (dl && typeof dl.close === 'function') dl.close();
      else if (dl) dl.removeAttribute('open');
      return;
    }
    // Arka plana tıklama diyaloğu kapatır
    if (t.tagName === 'DIALOG' && t.classList.contains('sk-dialog') && typeof t.close === 'function') t.close();
  });
  d.addEventListener(
    'close',
    function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('sk-dialog')) return;
      var op = lastOpener && lastOpener.isConnected ? lastOpener : q('[data-sk-open="' + t.id + '"]');
      if (op) {
        op.setAttribute('aria-expanded', 'false');
        if (d.activeElement !== op) op.focus();
      }
    },
    true
  );

  /* ---------- Yorum filtreleri ----------
     Bu davranış bölümün kendisine taşındı (sections/sharky-reviews.liquid,
     {% javascript %}): filtre yalnızca yorumu olan sayfada render ediliyor ve
     id'ler bölüm başına benzersiz. Buradaki global sürüm iki kez bağlanıyordu. */

  ready(function () {
    qa('[data-sk-open]').forEach(function (o) {
      o.setAttribute('aria-haspopup', 'dialog');
      o.setAttribute('aria-expanded', 'false');
    });
    syncPending();
    initSticky();
  });

  /* ---------- Hareketler ---------- */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-count'));
    if (!isFinite(to)) return;
    var start = null;
    var dur = 1300;
    function step(t) {
      if (start === null) start = t;
      var p = Math.min((t - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(to * e));
      if (p < 1) window.requestAnimationFrame(step);
      else el.textContent = String(to);
    }
    el.textContent = '0';
    window.requestAnimationFrame(step);
    // Sekme arka plandayken animasyon kareleri durabilir; son değer her durumda yazılsın
    window.setTimeout(function () {
      el.textContent = String(to);
    }, dur + 600);
  }

  ready(function () {
    if (reduce || designMode) return;

    // Sepet ikonu: ürün eklenince küçük bir zıplama
    var cart = q('cart-icon');
    if (cart && 'MutationObserver' in window) {
      var last = cart.textContent;
      new MutationObserver(function () {
        var now = cart.textContent;
        if (now === last) return;
        last = now;
        cart.classList.remove('sk-bump');
        void cart.offsetWidth;
        cart.classList.add('sk-bump');
      }).observe(cart, { childList: true, subtree: true, characterData: true });
    }

    if (!('IntersectionObserver' in window)) return;
    root.classList.add('sk-js');

    // Kaydırınca bir kez beliren bölümler (ilk ekranda görünenler beklemez)
    var groups = [
      ['[id$="__product"] media-gallery', 0],
      ['[id$="__statement"] .sk-wrap > *', 80],
      ['[id$="__cards"] .sk-card', 110],
      ['[id$="__facts"] .sk-wrap > :not(dl)', 70],
      ['[id$="__facts"] .sk-facts__row', 50],
      ['[id$="__shophead"] .sk-wrap > *', 70],
      ['[id$="__editorial"] .media-block', 0],
      ['[id$="__editorial"] .media-with-content__content', 120],
      ['[id$="__videos"] .text-block', 0],
      ['[id$="__videos"] deferred-media', 120],
      ['[id$="__faq"] .text-block', 0],
      ['[id$="__faq"] .accordion', 100],
      ['[id$="__cta"] .text-block', 0],
      ['[id$="__cta"] .button, [id$="__cta"] a.button-custom', 160],
      ['[id$="__story_home"] .media-with-content__content, [id$="__story_character"] .media-with-content__content, [id$="__story_gift"] .media-with-content__content', 0]
    ];
    var targets = [];
    var seen = [];
    groups.forEach(function (g) {
      qa(g[0]).forEach(function (el, i) {
        if (seen.indexOf(el) !== -1) return;
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
        seen.push(el);
        el.classList.add('sk-reveal');
        el.style.setProperty('--sk-d', i * g[1] + 'ms');
        targets.push(el);
      });
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var t = en.target;
          t.classList.add('sk-in');
          io.unobserve(t);
          // Animasyon bitince geçici sınıfları kaldır; hover gibi diğer geçişler gecikmesiz çalışsın
          window.setTimeout(function () {
            t.classList.remove('sk-reveal', 'sk-in');
            t.style.removeProperty('--sk-d');
          }, 1200 + (parseInt(t.style.getPropertyValue('--sk-d'), 10) || 0));
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );
    targets.forEach(function (el) {
      io.observe(el);
    });

    // Sayaçlar: görününce bir kez 0'dan değerine sayar
    var counters = qa('[data-count]');
    if (counters.length) {
      var co = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            qa('[data-count]', en.target).forEach(countUp);
            co.unobserve(en.target);
          });
        },
        { threshold: 0.4 }
      );
      qa('.sk-stat').forEach(function (s) {
        qa('[data-count]', s).forEach(function (n) {
          n.textContent = n.getAttribute('data-count');
        });
        co.observe(s);
      });
    }
  });
  /* ---------- Paket seçici ve e-posta kaydı penceresi ---------- */
  ready(function () {
    qa('[data-sk-bundle]').forEach(function (box) {
      var scope = box.closest('.shopify-section') || d;
      var qty = q('input[name="quantity"]', scope);
      var radios = qa('input[name="sk-bundle"]', box);
      function mark() {
        radios.forEach(function (r) {
          r.closest('label').classList.toggle('is-on', r.checked);
        });
      }
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (qty && r.checked) {
            qty.value = r.value;
            qty.dispatchEvent(new Event('input', { bubbles: true }));
            qty.dispatchEvent(new Event('change', { bubbles: true }));
          }
          mark();
        });
      });
      if (qty) {
        qty.addEventListener('change', function () {
          var v = String(parseInt(qty.value, 10) || 1);
          radios.forEach(function (r) {
            r.checked = r.value === v;
          });
          mark();
        });
      }
    });

    var dlg = q('#sk-pop');
    if (!dlg || designMode || typeof dlg.showModal !== 'function') return;
    function get(k) {
      try {
        return window.localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    }
    function set(k, v) {
      try {
        window.localStorage.setItem(k, v);
      } catch (e) {}
    }
    function openPop() {
      if (dlg.open || q('dialog[open]')) return;
      try {
        dlg.showModal();
      } catch (e) {}
    }
    function closePop() {
      try {
        dlg.close();
      } catch (e) {}
      set('sk-pop-seen', String(Date.now()));
    }
    qa('[data-sk-pop-close]', dlg).forEach(function (b) {
      b.addEventListener('click', closePop);
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) closePop();
    });
    if (q('[data-sk-pop-ok]', dlg)) {
      set('sk-pop-done', '1');
      openPop();
      return;
    }
    if (get('sk-pop-done')) return;
    if (q('featured-product-information')) return;
    // never interrupt a purchase: no automatic popup on product or cart pages
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:products|cart)(?:\/|$)/i.test(window.location.pathname)) return;
    var seen = parseInt(get('sk-pop-seen') || '0', 10);
    if (seen && Date.now() - seen < 14 * 86400000) return;
    var shown = false;
    function trigger() {
      if (shown) return;
      if (isTextEntry(d.activeElement)) {
        window.setTimeout(trigger, 5000);
        return;
      }
      shown = true;
      openPop();
    }
    window.setTimeout(trigger, 20000);
    onAnyScroll(function onPopScroll() {
      var span = scrollSpan();
      if (span > 0 && scrollPos() / span > 0.45) {
        d.removeEventListener('scroll', onPopScroll, true);
        window.setTimeout(trigger, 1200);
      }
    });
  });
  /* ---------- Galeri: kaydırılabilir alan klavyeyle erişilebilir olsun ---------- */
  ready(function () {
    function fixGallery() {
      qa('media-gallery slideshow-slides').forEach(function (s) {
        if (s.getAttribute('tabindex') !== '0') s.setAttribute('tabindex', '0');
        if (!s.hasAttribute('role')) s.setAttribute('role', 'group');
        if (!s.hasAttribute('aria-label')) s.setAttribute('aria-label', 'Product images');
      });
    }
    fixGallery();
    d.addEventListener('shopify:section:load', fixGallery);
  });
  /* ---------- Beden bulucu (tedarikçi beden tablosundan; garanti değildir) ---------- */
  ready(function () {
    qa('[data-sk-fit]').forEach(function (form) {
      var dlg = form.closest('dialog');
      var tables = qa('.sk-table', dlg);
      var out = q('[data-sk-fit-out]', form);
      function range(t) {
        var m = String(t).match(/(\d+(?:\.\d+)?)\s*[\u2013-]\s*(\d+(?:\.\d+)?)/);
        return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
      }
      function rows(tbl) {
        return qa('tbody tr', tbl)
          .map(function (tr) {
            var th = q('th', tr);
            var h = q('td[data-label="Height"]', tr);
            var w = q('td[data-label="Weight"]', tr);
            return th && h && w ? { size: th.textContent.trim(), h: range(h.textContent), w: range(w.textContent) } : null;
          })
          .filter(function (r) {
            return r && r.h && r.w;
          });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var g = parseInt(form.elements.g.value, 10) || 0;
        var H = parseFloat(form.elements.h.value);
        var W = parseFloat(form.elements.w.value);
        var list = rows(tables[g]);
        out.textContent = '';
        if (!isFinite(H) || !isFinite(W) || !list.length) {
          out.textContent = 'Please enter your height and weight.';
          return;
        }
        var minH = Math.min.apply(null, list.map(function (r) { return r.h[0]; }));
        var maxH = Math.max.apply(null, list.map(function (r) { return r.h[1]; }));
        var minW = Math.min.apply(null, list.map(function (r) { return r.w[0]; }));
        var maxW = Math.max.apply(null, list.map(function (r) { return r.w[1]; }));
        if (H < minH - 2 || H > maxH + 2 || W < minW - 2 || W > maxW + 2) {
          out.textContent = 'Your measurements are outside our chart (height ' + minH + '\u2013' + maxH + ' cm, weight ' + minW + '\u2013' + maxW + ' kg). Email us at info@sharkypyjamas.com and we will help you choose.';
          return;
        }
        var best = null;
        var bestScore = 1e9;
        list.forEach(function (r) {
          var s = Math.abs(H - (r.h[0] + r.h[1]) / 2) / (r.h[1] - r.h[0] || 1) + Math.abs(W - (r.w[0] + r.w[1]) / 2) / (r.w[1] - r.w[0] || 1);
          if (s < bestScore) {
            bestScore = s;
            best = r;
          }
        });
        var label = (g === 0 ? "Women's " : "Men's ") + best.size;
        out.textContent = 'We suggest ' + label + '. Between two sizes? Choose the larger one for a roomier fit. Measurements may differ by 1\u20132 cm.';
        var value = (g === 0 ? 'Womens ' : 'Mens ') + best.size;
        var radio = qa('input[data-option-name="Size"]').filter(function (i) {
          return i.value === value;
        })[0];
        if (radio) {
          var btn = d.createElement('button');
          btn.type = 'button';
          btn.className = 'sk-btn sk-btn--primary';
          btn.textContent = 'Choose ' + label;
          btn.addEventListener('click', function () {
            radio.click();
            try {
              dlg.close();
            } catch (err) {}
          });
          out.appendChild(d.createElement('br'));
          out.appendChild(btn);
        }
      });
    });
  });
})();

